var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_c('img',{attrs:{"src":_vm.orderType.icon,"width":"25"}})])]}}])},[_c('span',[_vm._v(_vm._s(_vm.orderType.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }